import { Dashboard } from '@carboncopyco/components';
import { selectOrganizationId } from '@carboncopyco/data';
import { useSelector } from 'react-redux';
import { useCustomNavigate } from '../../hooks/useCustomNavigate';

export const AnalyticsDashboard = () => {
  const organizationId = useSelector(selectOrganizationId);

  const {
    navigateToDemoPageByWorkspace,
    navigateToTourPageByWorkspace,
    navigateToDemoPreview,
    navigateToTourPreview,
    navigateToPlaybookPageByWorkspace,
    links,
  } = useCustomNavigate();

  return (
    <div className="flex flex-col items-center h-full overflow-y-hidden w-full">
      <Dashboard
        organizationId={organizationId}
        planId="environment"
        goToDemo={(id, workspaceId) =>
          navigateToDemoPageByWorkspace(String(id), workspaceId)
        }
        goToDemoPreview={({ id, firstUrl, workspaceId }) => {
          navigateToDemoPreview({
            id,
            firstUrl,
            workspaceId,
          });
        }}
        goToTour={navigateToTourPageByWorkspace}
        demoPagePath={(demoId, workspaceId) =>
          links.getDemoPageLinkByWorkspace(Number(demoId), workspaceId)
        }
        goToArchivedDemoPreview={({ id, firstUrl, workspaceId }) => {
          navigateToDemoPreview({
            id,
            removeDeleted: false,
            firstUrl,
            workspaceId,
          });
        }}
        tourPagePath={(tourId, workspaceId) =>
          links.getTourPageLinkByWorkspace(Number(tourId), workspaceId)
        }
        goToTourPreview={(tourId) => {
          navigateToTourPreview(tourId);
        }}
        playbookPagePath={links.getPlaybookPageLinkByWorkspace}
        goToPlaybook={navigateToPlaybookPageByWorkspace}
      />
    </div>
  );
};
